import { Form, Spin, TreeSelect } from "antd";
import React from "react";
import { TTranslate } from "../../../../core/service/locale/TranslationService";
import { IOrganisationIndexCategory } from "../../../../organisations/model/OrganisationIndexCategory";
import { TOrganisationIndexTreeItem } from "../../../../organisations/presenter/model/OrganisationIndexTreePresentationModel";

export interface Props {
  translate: TTranslate;
  indexTrees: TOrganisationIndexTreeItem[][];
  indexCategories?: IOrganisationIndexCategory[];
  onSelect(selectedItems: string[]): void;
  loading?: boolean;
}

export interface State {
  checkedItems: string[][];
  expandedKeys?: string[];
  autoExpandParent: boolean;
  selectedValues: string[][];
}

export default class IndexTreeSelectInput extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      checkedItems: [],
      expandedKeys: undefined,
      autoExpandParent: true,
      selectedValues: []
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (index, value) => {
    let { selectedValues } = this.state;
    selectedValues[index] = value;
    let allValues = selectedValues.flat();
    this.props.onSelect(allValues);
    this.setState({ selectedValues });
  };

  render() {
    const { indexTrees, loading, indexCategories, translate } = this.props;
    return (
      <>
        <Spin
          spinning={loading}
          style={{
            height: "100%",
            marginTop: loading ? 20 : 0
          }}
        >
          {indexTrees?.map((tree, index) => {
            return (
              <Form.Item
                key={`classifier-${index}`}
                name={`classifier-${index}`}
                label={
                  indexCategories?.[index]?.name ||
                  translate("search.advanced.index")
                }
              >
                <TreeSelect
                  key={`tree-select-${index}`}
                  showSearch
                  fieldNames={{
                    label: "title",
                    value: "key",
                    children: "children"
                  }}
                  style={{ width: "100%" }}
                  value={this.state.selectedValues[index]}
                  dropdownStyle={{ maxHeight: 600, overflow: "auto" }}
                  placeholder={translate("search.advanced.index_placeholder")}
                  filterTreeNode
                  treeNodeFilterProp={"title"}
                  allowClear
                  treeCheckable
                  showCheckedStrategy={"SHOW_PARENT"}
                  multiple
                  onChange={(value) => {
                    this.onChange(index, value);
                  }}
                  treeData={tree}
                />
              </Form.Item>
            );
          })}
        </Spin>
      </>
    );
  }
}
